import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Dmarc/DmarcManagementStatus'

export const FETCH_DMARC_INFO_REQUEST = createAsyncTypes('FETCH_DMARC_INFO_REQUEST', typeKey)
export const SUBMIT_DMARC_INFO_REQUEST = createAsyncTypes('SUBMIT_DMARC_INFO_REQUEST', typeKey)
